// AUTO-GENERATED Mon May 05 2025 11:28:59 GMT+0200 (Central European Summer Time) do not edit or replace
export const EVA_API_VERSION = 784;
//# sourceMappingURL=api-version.js.map